export default __webpack_public_path__ + "static/media/logo_short.23b919f2.svg";